import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import useLogout from '../../../hooks/useLogout';
import { RealMoneyStatus } from '../../../types/status';
import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_WeXve_sent_you_a_new_code_to_t_ELL,
  TXTWCL_Invalid_codeX_Please_try_again_ELL,
  TXTWCL_Okay,
  TXTWCL_Please_come_back_later_2,
  TXTWCL_Please_try_again,
  TXTWCL_SorryX_youXve_made_too_many_at_ELL,
  TXTWCL_There_has_been_an_issue_with_y_ELL,
  TXTWCL_You_can_try_again_in_1_hourX
} from './MobileValidationErrors.messages.json';

interface Props {
  onClose(): void;
  code: string;
}

const MobileValidationErrors: React.FC<Props> = ({ onClose, code }) => {
  let title;
  const isUS = useSelector(select.cms.isSiteUS);
  const logout = useLogout();

  switch (code) {
    case RealMoneyStatus.EXCEEDED_VALIDATION_ATTEMPTS:
      title = isUS ? TXTWCL_Please_try_again : TXTWCL_Please_come_back_later_2;
      break;
    default:
      title = TXTWCL_There_has_been_an_issue_with_y_ELL;
  }

  const handleClose = () => {
    if (code === RealMoneyStatus.EXCEEDED_VALIDATION_ATTEMPTS && !isUS) {
      logout();
    }
    onClose();
  };

  let bodyMessage;

  switch (code) {
    case RealMoneyStatus.INVALID_MOBILE_CODE:
      bodyMessage = (
        <Typography>
          <Translation {...TXTWCL_Invalid_codeX_Please_try_again_ELL} />
        </Typography>
      );
      break;
    case RealMoneyStatus.EXCEEDED_VALIDATION_ATTEMPTS:
      bodyMessage = (
        <Typography>
          <Translation {...TXTWCL_SorryX_youXve_made_too_many_at_ELL} />{' '}
          <Translation
            {...(isUS
              ? TXTCLI_WeXve_sent_you_a_new_code_to_t_ELL
              : TXTWCL_You_can_try_again_in_1_hourX)}
          />
        </Typography>
      );
      break;
  }

  return (
    <Prompt
      onClose={handleClose}
      variant="default"
      title={{ translation: title }}
      onPrimaryButtonClick={handleClose}
      primaryButton={{ translation: TXTWCL_Okay }}
    >
      {bodyMessage}
    </Prompt>
  );
};

export default MobileValidationErrors;
